import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=56f39a69&"
import script from "./Crear.vue?vue&type=script&lang=js&"
export * from "./Crear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports